import { Attendee } from '@alucio/aws-beacon-amplify/src/models';
import { FormValuesType } from 'src/components/CustomFields/CustomFieldValueUtilities';

export enum MEETING_SUBMIT_TYPE {
  DEFAULT,
  SILENT_SAVE,
  SAVE_TO_CRM,
  SUBMIT_LOCK_TO_CRM,
}

export interface AttendeeForm extends Attendee {
  crmValues?: FormValuesType;
}
